const raGlobalPositionTags = () => ({
    alert_widget_link: {
        categoriaEvento: "interaccion en invertimos por ti",
        accionEvento: "siempre informado",
        etiquetaEvento: "sigue leyendo",
    },
});

module.exports = { raGlobalPositionTags };